"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialiseComponents = initialiseComponents;
exports.renderErrorState = renderErrorState;
exports.renderLoadingState = renderLoadingState;
var _renderError, _renderLoading;

function initialiseComponents(renderError, renderLoading) {
	_renderError = renderError;
	_renderLoading = renderLoading;
}

function renderErrorState(retry) {
	return _renderError ? _renderError(retry) : undefined;
}

function renderLoadingState(loadingOptions) {
	return _renderLoading ? _renderLoading(loadingOptions) : undefined;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-component/dist/componentConfiguration.js
 ** module id = 259
 ** module chunks = 0
 **/